import React, {useContext, useEffect} from "react";
import styles from "./bpmnModel/BpmnModel.module.scss";
import appContext from "../../../../context/appContext";
import {useHistory} from "react-router-dom";

const BpmnModel = ({ showModal = false, handleTriggerShowModal }) => {

  const context = useContext(appContext);
  const history = useHistory();

  const handleShowBpmn = () => {
      history.push(`/show-bpmn?url=${context.handleConformanceCheckingData().file}`);
      context.handleAddTab(101, 'Show Bpmn Model', `/show-bpmn?url=${context.handleConformanceCheckingData().file}`);
  }

  const handleEdit = (e) => {
    e.stopPropagation();
    history.push(`/conformance-checking-list`);
  }

  return (
    <div onClick={handleShowBpmn} className={[styles.ModalBox, (showModal ? styles.show : styles.hide)].join(' ')}>
      <div>
        <div className={styles.bpmnModelItem}>
          <div>
            <div className={styles.title}>
              <span>{ context.handleConformanceCheckingData().title || "BPMN Model" }</span>
            </div>
            <div className={styles.date}>
              <span>{ context.handleConformanceCheckingData().created }</span>
            </div>
            <div className={styles.description}>
              {(context.handleConformanceCheckingData().description !== null && context.handleConformanceCheckingData().description !== undefined && context.handleConformanceCheckingData().description !== '') ? <p>{ context.handleConformanceCheckingData().description }</p> : <div className={[styles.emptyDesc, 'd-flex align-items-center justify-content-center'].join(' ')}>Description</div> }
            </div>
            <div className={styles.icons}>
            <span onClick={handleEdit}>
              <i>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.57693 2.32422H6.4611C3.8986 2.32422 2.29193 4.13839 2.29193 6.70672V13.6351C2.29193 16.2034 3.8911 18.0176 6.4611 18.0176H13.8144C16.3853 18.0176 17.9844 16.2034 17.9844 13.6351V10.2784" stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.35652 9.10074L13.584 2.87324C14.3599 2.09824 15.6174 2.09824 16.3932 2.87324L17.4074 3.88741C18.1832 4.66324 18.1832 5.92158 17.4074 6.69658L11.1499 12.9541C10.8107 13.2932 10.3507 13.4841 9.87069 13.4841H6.74902L6.82736 10.3341C6.83902 9.87074 7.02819 9.42908 7.35652 9.10074Z" stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12.6377 3.83545L16.4427 7.64045" stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </i>
            </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default BpmnModel;